module.exports = __webpack_public_path__ + "img/newsList-phone.7c768907.png";